var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yj-navigator" }, [
    !_vm.tab.hidden
      ? _c("div", { staticClass: "main-tabs" }, [
          _c(
            "ul",
            _vm._l(_vm.navigators, function(item, index) {
              return _c(
                "li",
                {
                  key: "li" + index,
                  class: { active: _vm.tab === item },
                  on: {
                    click: function($event) {
                      return _vm.tabAction(item)
                    }
                  }
                },
                [
                  _c("p", { staticClass: "nav-name" }, [
                    _vm._v(_vm._s(item.permName))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "nav-active" })
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "item-right" },
            [
              _vm.isExamListNav && _vm.userInfo.isAdmin
                ? _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content: "回收站",
                        placement: "bottom"
                      }
                    },
                    [
                      _c("p", {
                        staticClass: "yj-nav-icon icon-trash",
                        on: {
                          click: function($event) {
                            _vm.checkPermission(function() {
                              _vm.$router.push("/region/exam/single/recycle")
                            })
                          }
                        }
                      })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showMultipleReport
                ? _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content: "自定义报告",
                        placement: "bottom"
                      }
                    },
                    [
                      _c("p", {
                        staticClass: "yj-nav-icon icon-report",
                        on: {
                          click: function($event) {
                            return _vm.$router.push("/region/exam/multiple")
                          }
                        }
                      })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    effect: "dark",
                    content: "去审核",
                    placement: "bottom"
                  }
                },
                [
                  _vm.userInfo.isAdmin === 1 && _vm.reportCheck
                    ? _c(
                        "p",
                        {
                          staticClass: "yj-nav-icon icon-examine",
                          staticStyle: { position: "relative" },
                          on: {
                            click: function($event) {
                              _vm.checkPermission(function() {
                                _vm.$router.push("/region/exam/single/audit")
                              })
                            }
                          }
                        },
                        [
                          _vm.auditExamCount > 0
                            ? _c("span", { staticClass: "btn-tag" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.auditExamCount > 99
                                      ? "99+"
                                      : _vm.auditExamCount
                                  )
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    effect: "dark",
                    content: "强制刷新",
                    placement: "bottom"
                  }
                },
                [
                  _c("p", {
                    staticClass: "yj-nav-icon icon-refresh",
                    on: { click: _vm.loadSite }
                  })
                ]
              ),
              _vm._v(" "),
              _vm.isSelf
                ? _c(
                    "el-popover",
                    {
                      attrs: { trigger: "hover" },
                      model: {
                        value: _vm.visible,
                        callback: function($$v) {
                          _vm.visible = $$v
                        },
                        expression: "visible"
                      }
                    },
                    [
                      _c("p", { staticStyle: { margin: "10px 0" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.userInfo.nickName || _vm.userInfo.loginName
                            ) +
                            " (" +
                            _vm._s(_vm.userInfo.schoolName) +
                            ")\n          "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n          " + _vm._s(_vm.roleNames) + "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { "text-align": "right", margin: "0" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "text" },
                              on: {
                                click: function($event) {
                                  _vm.visible = false
                                }
                              }
                            },
                            [_vm._v("关闭")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "mini" },
                              on: { click: _vm.logout }
                            },
                            [_vm._v("登出")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "yj-nav-icon el-icon-user",
                        attrs: { slot: "reference" },
                        slot: "reference"
                      })
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.tab.children && _vm.tab.children.length > 0
      ? _c(
          "div",
          { staticClass: "sub-tabs" },
          [
            _c(
              "el-tabs",
              {
                staticStyle: { float: "left" },
                on: { "tab-click": _vm.subTabAction },
                model: {
                  value: _vm.subModuleUrl,
                  callback: function($$v) {
                    _vm.subModuleUrl = $$v
                  },
                  expression: "subModuleUrl"
                }
              },
              _vm._l(_vm.tab.children, function(item, index) {
                return _c("el-tab-pane", {
                  key: "tab" + index,
                  attrs: { label: item.permName, name: item.moduleUrl }
                })
              }),
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7957162e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7957162e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/v2/views/components/Navigator.vue
// module id = null
// module chunks = 